<section class="radio-button-group flex gap-12 mb-24">
  @for (type of vm.claimTypes; track type.flowIdempotencyKey; let index = $index) {
    <app-radio-button
      variant="blue"
      [ngModel]="vm.formValue?.['claim-type']"
      [includeResetOption]="false"
      name="claim-type"
      [index]="index"
      [optionValue]="type"
      [disabled]="vm.submittingValue"
    >
      <p class="label">{{ claimTypesTitles[type.title] || type.title }}</p>
    </app-radio-button>
  }

  @if (!vm.formValid && vm.formSubmitted) {
    <section class="error mt-8">
      <i class="fa-light fa-circle-exclamation"></i>

      <p class="body">Select an option to continue.</p>
    </section>
  }
</section>
